// extracted by mini-css-extract-plugin
export var deleteModal = "_qx-0";